import { createUsePermissions } from "./createUsePermissions";

export const useTemplatesPermissions = createUsePermissions("pb.template");
